import logo from './logo.svg';
import ProfilePic from './components/profilePic.js';
import ContactInfo from './components/contact.js';
import AboutMe from './components/about.js';
import Footer from './components/footer.js';
import './App.css';

function App() {
  return (
      <div className='App'>
        <ProfilePic />
        <ContactInfo />
        <AboutMe />
        <Footer />
      </div>
        

  );
}

export default App;
